// extracted by mini-css-extract-plugin
export default {"hidden-label":"B4yDe","hiddenLabel":"B4yDe"};